import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import queryString from 'query-string';

const BASE_ENDPOINT = '/api/status-cheques-count';

export const statusChequeCountApi = createApi({
  reducerPath: 'statusChequeCountApi',
  tagTypes: ['ChequeCounts'],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_REPORT_PORT,
    prepareHeaders: (headers) => {
      // const token = localStorage.getItem('token');
      // console.log('🔑 CHEQUE PREPARE HEADERS token:', token);
      headers.set('Accept', 'application/json');
      headers.set('Authorization', `Bearer ${localStorage.getItem('token')}`);
      headers.set('X-Auth-Token', `Bearer ${localStorage.getItem('token')}`);

      return headers;
    },
    paramsSerializer: (params) => {
      return queryString.stringify(params, {
        skipNull: true,
        skipEmptyString: true,
      });
    },
  }),
  endpoints: (builder) => ({
    fetchChequeCounts: builder.query({
      query: (params) => ({
        url: BASE_ENDPOINT,
        method: 'GET',
        params,
      }),
      providesTags: ['ChequeCounts'],
    }),
  }),
});

export const { useFetchChequeCountsQuery } = statusChequeCountApi;
